import { Injectable } from '@angular/core';
import { HttpRequestService } from '../http/http-request.service';

@Injectable()
export class OrderService {

    constructor(private httpRequestService: HttpRequestService) {
    }
}
